import React from 'react';
import ContentLoader from "react-content-loader";

const DetailsDecLoader1 = () => (
  <ContentLoader
    speed={2}
    width={500}
    height={200}
    viewBox="0 0 500 200"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    {/* First large rectangle */}
    <rect x="0" y="0" rx="4" ry="4" width="50%" height="30" />
    

    {/* Second rectangle */}
    <rect x="0" y="60" rx="4" ry="4" width="100%" height="20" />
    
    {/* Third rectangle */}
    <rect x="0" y="120" rx="4" ry="4" width="100%" height="20" />
  </ContentLoader>
);

export default DetailsDecLoader1;
